const PATCH_NOTES = [
  {
    title: `Versión ${process.env.VUE_APP_VERSION}`,
    date: '2025-10-8', // '8 de Octubre de 2025',
    changes: [
      {
        title: 'Optimización del flujo de altas',
        description: [
          'Nuevo flujo para la creación de empresas, certificados, productos y sociedades',
        ]
      },
      {
        title: 'Mejoras en la configuración de empresa',
        description: [
          'En el detalle se añade la posibilidad de configurar Firma Delegada',
          'Los submenús para configuración Veri*Factu y TicketBAI se agrupan en \'Reporte Hacienda\'',
          'Se añade opción para activación de Veri*Factu y TicketBAI',
          'Se añade personalización de plantillas a nivel de empresa'
        ]
      },
      {
        title: 'Nuevas funcionalidades de Usuario',
        description: [
          'Posibilidad de activación de usuarios',
          'Se añaden nuevas acciones para \'Resetear dobler factor\' y \'Reenviar correo para cambio de contraseña\'',
        ]
      },
      {
        title: 'Mejora de Webhooks',
        description: [
          'Se habilita el tipo de autenticación para \'Token\' y \'Usuario y contraseña\'',
          'Se añaden nuevos tipos de subscripción para Veri*Factu y SOAPFault AEAT'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.2.0',
    date: '2025-09-18', // '18 de Septiembre de 2025',
    changes: [
      {
        title: 'Nuevas funcionalidades de Facturas',
        description: [
          'Se añade funcionalidad de rectificar facturas emitidas.',
          'Se añade la funcionalidad para emitir facturas de forma recurrente.'
        ]
      },
      {
        title: 'Mejoras en la Interfaz de emisión',
        description: [
          'Se añade la posibilidad de emitir proformas, presupuestos y facturas simplificadas.',
          'Se añaden opciones para incluir observaciones a nivel de línea de factura.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.1.1',
    date: '2025-07-02', // '02 de Julio de 2025',
    changes: [
      {
        title: 'Mejoras en la Interfaz de emisión',
        description: [
          'Se añade la opción de crear sociedades, sedes, centros administrativos, IRPFs y productos desde su paso correspondiente sin interrumpir la emisión.',
          'Se añade la funcionalidad de auto-selección del emisor de una factura si solo se tiene una empresa disponible.',
          'Se abre el diálogo de añadir producto automáticamente cuando no hay líneas de factura.'
        ]
      },
      {
        title: 'Mejoras Veri*Factu',
        description: [
          'Se añade un nuevo apartado de configuración para integración con Veri*Factu a nivel de empresa.',
          'Se añade la opción de subir registros Veri*Factu manualmente desde el menú de "Subir facturas".'
        ]
      },
      {
        title: 'Mejoras en las vistas de tabla',
        description: [
          'Se añade la conservación de la selección entre páginas.',
          'La selección será limpiada en caso de aplicación de filtros, navegación o recarga de la página.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.1.0',
    date: '2025-06-05', // '05 de Junio de 2025',
    changes: [
      {
        title: 'Mejoras en la Interfaz de emisión',
        description: [
          'Se añade la opción de contraer el resumen de la factura emitida.',
        ]
      },
      {
        title: 'Nueva funcionalidad de APIKeys',
        description: [
          'Se añade la opción de tener tokens para la API de larga caducidad',
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.0.0',
    date: '2025-05-09', // '09 de Mayo de 2025',
    changes: [
      {
        title: 'Nueva funcionalidad de Multiidioma',
        description: [
          'Se añaden idiomas \'Inglés\', \'Francés\', \'Alemán\', \'Catalán\', \'Gallego\' y \'Euskera\'.',
        ]
      },
      {
        title: 'Cambio en Agenda',
        description: [
          'Agenda cambia de nombre a \'Sociedades\'.',
          'Se añade a Sociedades los apartados \'Empresas vinculadas\' y \'Histórico\'.',
          'Se añade a Sedes los apartados \'Email de contacto\' y \'Cuentas bancarias\'.',
        ]
      },
      {
        title: 'Nuevo módulo de Interfaz de emisión de facturas',
        description: [
          'Es necesario tener activado el módulo \'Emisión de facturas\' para un correcto funcionamiento.',
          'Se añade nueva funcionalidad para emitir facturas por pasos.',
          'Se añaden los pasos de emisión de facturas \'Intervinientes\', \'Detalle\', \'Líneas\', \'Pago\' y \'Adjuntos\'.',
          'Se añade resumen de la factura.',
        ]
      },
      {
        title: 'Nuevo módulo de Veri*Factu',
        description: [
          'Se añaden registros de Veri*Factu.',
          'Se añaden los estados \'Correcto\', \'Aceptado con errores\', \'Incorrecto\' y \'Pendiente de notificar\'.',
          'Se añade detalle de registros.',
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 6.1.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'Configuración Autenticación AAD/SAML2',
        description: [
          'Módulo de autenticación con integración a través de Azure Active Directory',
          'Módulo de autenticación con integración a través del estándar SAML2',
          'Inicio de sesión dinámica en función del tipo de autenticación del usuario'
        ]
      },
      {
        title: 'Nuevos módulos de Webhooks',
        description: [
          'Se añaden dos nuevos modulos para los eventos de las Facturas Emitidas y Recibidas',
          'Se añade nueva vista de configuracion de los Webhooks. Integracion con Microsoft Teams o Integracion personalizada (Zerocoma)'
        ]
      },
      {
        title: 'Nuevo módulo de TicketBAI-Batuz',
        description: [
          'Se añade un apartado de configuración para la integración a TicketBAI-Batuz.'
        ]
      },
      {
        title: 'Cambio en el flujo de \'Envío Externo\'',
        description: [
          'Se elimina el estado \'Envío Externo\'.',
          'Las facturas que se encuentren en este estado, pasarán al estado \'Enviada\'.',
          'Las facturas con pge \'Envío Externo\' ahora pasan por el flujo normal de facturas.'
        ]
      },
      {
        title: 'Eliminación de acciones en las facturas emitidas',
        description: [
          'Se eliminan todas las acciones \'Pasar a\' de las facturas en estado \'Sin Enviar\'.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 6.0.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'Nueva funcionalidad de Agenda',
        description: [
          'Se añade un apartado en el que se pueden agregar distintos tipos de contactos.'
        ]
      },
      {
        title: 'Nueva funcionalidad de Validación',
        description: [
          'Se cruzan los ficheros de la factura con sus esquemas y se comprueban los adjuntos de forma previa a la subida de la factura.'
        ]
      },
      {
        title: 'Nueva funcionalidad de Plantillas',
        description: [
          'Se agrega una nueva configuración con valores por defecto para la creación de nuevas empresas y nuevos grupos.'
        ]
      },
      {
        title: 'Nuevo módulo de Autofactura',
        description: [
          'Se añade la opción de subir y emitir autofacturas desde la plataforma.'
        ]
      },
      {
        title: 'Nuevo módulo de Agrupaciones',
        description: [
          'Se añade una sección para crear conjuntos de entidades (Empresas, Proveedores o Clientes) y utilizarlos posteriormente en filtros y otras partes del aplicativo.'
        ]
      },
      {
        title: 'Nuevo módulo de Personalización',
        description: [
          'Se añaden diferentes opciones de personalización como: Logos, colores, cuenta SMTP y emails personalizados.'
        ]
      },
      {
        title: 'Nuevo módulo de Plantilla PDF',
        description: [
          'Se añade la opción de generar una factura pdf a partir del facturae en base a una plantilla y configuración establecida.'
        ]
      },
      {
        title: 'Nuevo producto de EdasInvoiZEFiles',
        description: [
          'Se añade la opción de subir facturas con sus adjuntos desde el servicio EdasInvoiZEFiles.'
        ]
      },
      {
        title: 'Posibilidad de subir facturas recibidas',
        description: [
          'Se añade la opción de subir facturas recibidas manualmente desde el menú de "Subir facturas".'
        ]
      },
      {
        title: 'Reorganización de filtros',
        description: [
          'Se reorganizan los filtros de las secciones relativas a facturas.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 5.2.2',
    date: '2024-03-20', // '20 de Marzo de 2024',
    changes: [
      {
        title: 'Corrección de textos',
        description: [
          'Se corrigen algunos textos en la validación del licenciamiento.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Se corrige la desaparición de la columna "Detalle" de las tablas relacionadas con las facturas.'
        ]
      },
    ]
  },
  {
    title: 'Versión 5.2.1',
    date: '2024-03-18', // '18 de Marzo de 2024',
    changes: [
      {
        title: 'Actualización de textos',
        description: [
          'Se actualizan algunos textos dentro de la aplicación para una mayor descriptividad.'
        ]
      },
      {
        title: 'Mejoras de eficiencia',
        description: [
          'Se aplican mejoras en la eficiencia de los selectores dentro de la aplicación.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 5.2.0',
    date: '2024-02-27', // '27 de Febrero de 2024',
    changes: [
      {
        title: 'Ampliado los esquemas admitidos para emisión',
        description: [
          'Se añade compatibilidad y validación de otros esquemas a parte del Facturae.'
        ]
      },
      {
        title: 'Firmado y recuperación de facturas para envío externo',
        description: [
          'Se añade el Punto General de Entrega Envío externo, útil para realizar únicamente el firmado de las facturas para enviar de forma externa.'
        ]
      },
      {
        title: 'Nuevo Punto General de Entrega Cataluña (e-Fact)',
        description: [
          'Se añade el Punto General de Entrega e-Fact para el envío de facturas a las administraciones de cataluña no adheridas a FACe.',
          'Consulte las administraciones adheridas en #link:eFact#.'
        ],
        links: [
          {
            tag: 'eFact',
            linkName: 'e-Fact',
            url: 'https://efact.aoc.cat/bustia/receiver/list.htm'
          }
        ]
      },
      {
        title: 'Recuperación de ficheros enviados',
        description: [
          'Si la factura a enviar ha sufrido alguna alteración para el envío al Punto General de Entrega, se almacenará como documento relacionado de la factura.'
        ]
      },
      {
        title: 'Firma de terceros',
        description: [
          'Todos aquellos Facturaes que se firmen a través del certificado de Colaborador Social, se les incluirá nuestros datos como terceros en el nodo ThirdParty del Facturae.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Errores relacionados con los transformadores ya existentes.',
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 5.1.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nueva funcionalidad de Dashboard: Nueva vista con información útil sobre las facturas y el licenciamiento.'
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Correcciones menores.',
        ]
      },
    ]
  },
  {
    title: 'Versión 5.0.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nueva funcionalidad de Distribuidor: Gestiona múltiples clientes como distribuidor con provisionamiento con bolsa de licenciamiento o de forma libre.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 4.2.0',
    date: '2023-10-30', // '30 de Octubre de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nueva funcionalidad de Grupos. Las etiquetas ahora son grupos, los grupos mantienen la funcionalidad de etiquetas y añaden: gestión de usuarios, gestión ampliada de facturas.',
          'Actualización del perfil de usuario con información sobre los grupos a los que pertenece.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 4.1.0',
    date: '2023-08-11', // '11 de Agosto de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Incorporación de recepción de facturas en los PGE FACe y FACeB2B.',
          'Nuevos módulos disponibles para contratar. Puede consultarlos en la sección de configuración general.'
        ]
      },
    ]
  }, 
  {
    title: 'Versión 4.0.0',
    date: '2023-05-24', // '24 de Mayo de 2023',
    changes: [
      {
        title: 'Lanzamiento',
        description: [
          // 'Gestión y administración de ...',
        ]
      },
    ]
  }, 
  // {
  //   title: 'Versión 2.11.0',
  //   date: '2022-12-13', // '13 de Diciembre de 2022',
  //   changes: [
  //     {
  //       title: 'Nuevas características',
  //       description: [
  //         'Nuevo tipo de usuario: Usuario Consulta. Usuario para consulta y revisión de datos, similar al rol "Usuario" con restricciones a la hora de realizar acciones sobre facturas, solo puede visualizarlas y descargar el contenido de estas.',
  //         'Nueva funcionalidad de edición y eliminación de Metadatos Adicionales de una factura, accesible en el detalle de las facturas.',
  //         'Se ha añadido la opción de exportar un fichero excel de los errores detectados, desde el cuadro de diálogo de los detalles de errores del Dashboard.',
  //         'Se ha añadido una nueva opción de exportar un fichero excel del histórico completo de los errores detectados, de una empresa y una sede concretos, desde el cuadro de diálogo de los detalles de errores del Dashboard.',
  //         'Al seleccionar la acción "Excluir organismo asociado" desde la vista de facturas, se ha añadido la opción de excluir dicho organismo a todas las empresas del cliente, además de mantenerse la opción por defecto de solo excluir el organismo a la empresa asociada a esa factura.',
  //       ]
  //     },
  //     {
  //       title: 'Errores corregidos',
  //       description: [
  //         'Corregido error en la subida de facturas manualmente.',
  //         'Correciones en textos y descripciones.',
  //         'Otras correciones menores',
  //       ]
  //     },
  //   ]
  // }, 
]

export {
  PATCH_NOTES
}
